/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q6Inputs */

const en_viewer_faq_q6 = /** @type {(inputs: Viewer_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I tell a null from an empty string?`)
};

const ko_viewer_faq_q6 = /** @type {(inputs: Viewer_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null과 빈 문자열을 어떻게 구분하나요?`)
};

const ja_viewer_faq_q6 = /** @type {(inputs: Viewer_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null と空文字列はどう区別しますか`)
};

/**
* | output |
* | --- |
* | "How do I tell a null from an empty string?" |
*
* @param {Viewer_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q6 = /** @type {((inputs?: Viewer_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q6(inputs)
	if (locale === "ko") return ko_viewer_faq_q6(inputs)
	return ja_viewer_faq_q6(inputs)
});